import { competitionCode } from '@utilities/WindowContext';

import * as classes from '../styles.module.scss';

export type TableGroupConfig = {
  id: string;
  placeTitle: string;
  placeSubTitle?: string;
  start: number;
  end?: number;
  wrapperClassName?: string;
};

const baseConfig: TableGroupConfig[] = [
  {
    id: 'r16',
    placeTitle: 'straight_to_r16',
    start: 0,
    end: 8,
  },
  {
    id: 'po_seeded',
    placeTitle: 'play_off_places',
    placeSubTitle: 'draw_seeded',
    start: 8,
    end: 16,
  },
  {
    id: 'po_unseeded',
    placeTitle: 'play_off_places',
    placeSubTitle: 'draw_unseeded',
    start: 16,
    end: 24,
    wrapperClassName: classes.newFormatDashedCaption,
  },
  {
    id: 'eliminated',
    placeTitle: 'will_not_qualify',
    start: 24,
  },
];

const uylConfig: TableGroupConfig[] = [
  {
    id: 'r32',
    placeTitle: 'qualified_to_r32',
    start: 0,
    end: 22,
  },
  {
    id: 'eliminated',
    placeTitle: 'will_not_qualify',
    start: 22,
  },
];

export const tableGroupsConfig =
  {
    uyl: uylConfig,
  }[competitionCode?.toLowerCase()] ?? baseConfig;
